import { Jollywhere } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const jollywhereDictionary = createSimpleDictionary([
    { id: Jollywhere.Home, name: 'dictionaries.jollywhere.home' },
    { id: Jollywhere.Away, name: 'dictionaries.jollywhere.away' },
]);
